<template>
  <div class="article-list">
    <div class="title">
        <h2 class="rich-media-title">{{title}}</h2>
        <div class="account-info">
            <span class="account-avatar">
                <img class="account-avatar" src="../../../assets/logo.jpg" />
            </span>
            <a
            href="https://mp.weixin.qq.com/mp/profile_ext?action=home&amp;__biz=MzIxMjc2ODA4Mw==&amp;subscene=0#wechat_redirect"
            class="account-nickname-inner"
            >农业科普发生树</a>
        </div>
    </div>
    <Loading v-if="loading"/>
    <a v-for="(item, index) in list" :key="index"
        class="list-item"
        :href="`/quiz/agriculture/articles/${item.article_id}?source_from=list`"
        >
        <h3 class="sub-title">{{item.title}}</h3>
        <div
            class="cover"
            :data-cover="item.imgurl"
            :style="{ 'background-image': 'url(' + item.cover_image + '?imageView2/1/w/500/h/400' + ')','background-repeat':'no-repeat','background-position':'center','background-size':'cover' }"
        ></div>
    </a>
  </div>
</template>

<script>
import { Loading } from 'vant';
import { articleApi } from '@/apis'

const TITLES = {
    genetically: '转基因技术',
    food_safety: '食品安全',
    agri_production: '农业生产',
    rumor_smash: '谣言粉碎',
    social_hotspot: '社会热点'
}

export default {
    components: {
        Loading
    },
    watch:{
        "$route"() {
            this.init()
        }
    },
    data() {
        return {
            loading: true,
            title: '',
            list: []
        };
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            const {
                params: {
                    listName = '',
                }
            } = this.$route || {}
            this.title = TITLES[listName]
            try {
                const {body} = await articleApi.articlesGet({
                    params: {
                        topic: listName
                    }
                })
                this.list = body
                this.loading = false
            } catch (error) {
                console.log(error)
                this.loading = false
            }
        }
    }
};
</script>
<style lang="less">
.article-list {
    padding: 0 0 0 2rem;
    font-size: 14px;
    line-height: 1.5;
    /deep/.van-loading {
        text-align: center;
    }
    .title {
        padding: 2rem 0;
        border-bottom: 1px solid #e2e2e2;
        h2 {
            font-weight: 400;
            font-size: 22px;
            line-height: 1.2em;
            margin-bottom: 2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            word-break: break-all;
        }
        .account-info {
            display: flex;
            align-items: center;
            justify-content: flex-start;
        }
        .account-avatar{
            width: 2.5rem;
            height: 2.5rem;
            padding: 0;
            display: inline-block;
            background-color: #fff;
            border-radius: 50%;
            overflow: hidden;
            vertical-align: middle;
        }
        .account-nickname-inner {
            -webkit-box-flex: 1;
            padding-left: 1rem;
            word-wrap: break-word;
            word-break: break-all;
            color: #576b95;
        }

    }
    .list-item {
        display: flex;
        padding: 1rem 2rem 1rem 0;
        color: #000;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #e2e2e2;
        .sub-title {
            flex: 1;
            padding: 0;
            margin: 0;
            margin-right: 1rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            font-weight: 400;
        }
        .cover {
            width: 10rem;
            height: 8rem;
        }
    }
}
</style>
